import * as React from 'react';
import { Container, Typography } from "@mui/material";
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';

import AddDishFooter from '../components/AddDishFooter.jsx';
import ExtraCard from '../components/ExtraCard.jsx';
import QtyButton from '../components/QtyButton.jsx';
import BackButton from '../components/BackButton.jsx';
import { useState, useEffect } from "react";

import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from "../config/firebase.js";

// loads the page to display a dish from the menu
// allows customers to specify extras and write a note to the chef
// then add the dish and a quantiy to their order
function Dish() {

  // uses react router to pass params through to the next page
  // this avoids us having to call the backend again to get dish details
  // as the prvious page already did the call and has all relevant data
  const {state} = useLocation();
  const {dishInfo} = state;

  const fetchImageUrl = async (path) => {
    const storageRef = ref(storage, path);
  
    try {
      const url = await getDownloadURL(storageRef);
      return url;
    } catch (error) {
      console.error("Error fetching image URL:", error);
      return null;
    }
  };
  const [dishImage, setDishImage] = useState("");
  useEffect(() => {
    const get_dish_image = async () => {
      const url = await fetchImageUrl(dishInfo.imagePath);
      setDishImage(url);
    };

    get_dish_image();
  }, [])

  //make a comma seperated list of all the ingredients
  let ings = [];
  dishInfo["ingredients"].map((i) => {
    ings.push(i.name);
    ings.push(", ");
  });
  //remove the final comma, 
  ings.pop()

  //Object with all the available extras options
  const [extras, setExtras] = React.useState(() => {
    let list = {};
     for (let i = 0; i < dishInfo["available_extras"].length; i++) {
      let extra =  dishInfo["available_extras"][i];
      //add a quantity field
      extra.quantity = 0;
      list[extra.id] = extra;
    }
    return list;
  });
  
  //state for saving the written instructions for the chef
  const [instructions, setInstructions] = React.useState("");

  //getter for quantity of an given extra
  function getExtraQty(id) {
    return extras[id].quantity;
  }

  //setter for quantity of an given extra
  function setExtraQty(id, qty) {
    let copy = {...extras};
    copy[id].quantity = qty;
    setExtras(copy);
  }

  //fucntion which returns a list of extras components 
  function renderExtras() {
    let list = [];
    for (const [k, value] of Object.entries(extras)) {
      list.push(
        <div key={k}>
          <Box sx={{display:'flex', flexDirection:'row', justifyContent: 'space-between'}}>
            <ExtraCard extraInfo={value}></ExtraCard>
            <QtyButton getQty={() => getExtraQty(value.id)} setQty={(qty)=>setExtraQty(value.id, qty)}></QtyButton>
          </Box>
          <Divider></Divider>
        </div>
      );
    }
    return list
  }
  
  //page render

  return (
    <Box sx={{display: 'flex', flexDirection:'column', height: '100%', alignItems: 'center'}}>
      <Box sx={{maxWidth: { sx:1 }, overflowY: 'scroll', height: 4/5}}>
        <BackButton />
        <Container sx={{maxWidth: { sx:1, md: 3/5, paddingTop: 20 }}}>
          <img
            src={dishImage}
            width='100%'
            border='3px solid'
          />
          <Box sx={{display: 'flex', flexDirection:'row', height: '100%', justifyContent: 'space-between'}}>
            <Typography variant='h5'>{dishInfo.name}</Typography>
            <Typography variant="h6" sx={{mb: 5, fontWeight: 'bold'}}>${dishInfo.price}</Typography>
          </Box>
          <Typography variant='body2'>{dishInfo.description}</Typography>
          <Typography variant='body2' sx={{mt: 2}}>Ingredients: {ings}</Typography>
          <Typography variant='body2' sx={{mt: 2}}>Extras: </Typography>
          {
            renderExtras()
          }
          <TextField
            id="special instructions"
            label="Notes for the chef"
            placeholder="(optional)"
            multiline
            onChange={e => setInstructions(e.target.value)}
            sx = {{ mt: 2, width: 1}}
          />
        </Container>
      </Box>
      <AddDishFooter dishId={dishInfo.id} extras={() => {return extras}} instructions={() => {return instructions}}></AddDishFooter>
    </Box>
  );
}

export default Dish;